import httpClient from '../../utils/httpClient';
import { ApiSuccessResponse } from '../../utils/apiSchemas';
import { WgApplicationsEnum } from '../../utils/WgApplicationsEnum';

// Base route for UserAccess endpoints
const CUSTOMER_ROUTE = '/api/v1/portal/enrollment';

export interface CompletePreRegistrationPayload {
  userName: string;
  emailAddress: string;
  password: string;
  responsableName: string;
  responsableEmail: string;
  applications: WgApplicationsEnum[];
  fantasyName?: string;
  registrationName?: string;
  registrationId?: string;
}

export type CompletePreRegistrationResponse = string | boolean | null;

export const completeRegistrationFromPreRegistration = async (
  preRegistrationGuid: string,
  payload: CompletePreRegistrationPayload
): Promise<ApiSuccessResponse<CompletePreRegistrationResponse>> => {
  const response = await httpClient.post<ApiSuccessResponse<CompletePreRegistrationResponse>>(
    `${CUSTOMER_ROUTE}/complete-registration-from-pre-registration/${encodeURIComponent(preRegistrationGuid)}`,
    payload,
    {
      headers: { 'X-Skip-Auth': 'true' }
    }
  );
  return response.data;
};